import React, { useRef, useState } from "react";
import emailjs from "emailjs-com"; // 🔹 import EmailJS
import "./../styles/contact.css";  // Adicione o CSS para animação
import Maps from "../components/Maps";

const Contact = () => {
  const form = useRef();
  const [isLoading, setIsLoading] = useState(false); // Estado para controle de loading

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true); // Ativa o carregamento

    emailjs
      .sendForm(
        "service_kdotjxh",       // seu Service ID
        "template_ebdboc9",      // seu Template ID
        form.current,
        "G5kP-H0oETFbjSTtK"      // sua Public Key
      )
      .then(
        (result) => {
          setIsLoading(false); // Desativa o carregamento
          alert("Mensagem enviada com sucesso!");
          form.current.reset();
        },
        (error) => {
          setIsLoading(false); // Desativa o carregamento
          alert("Erro ao enviar mensagem. Tente novamente.");
        }
      );
  };

  return (
    <div className="contact-container">
      <h2 className="contact-title">Entrar em Contato Conosco</h2>
      <div className="contact-content">
        <div className="contact-info-box">
          <h3>Informações de Contato</h3>
          <p>
            Preencha o formulário e nossa equipe entrará em contato com você
            dentro de 24 horas.
          </p>
          <ul>
            <li>
              <i className="fa-solid fa-location-dot"></i>
              <p>Av. do Rio Bonito, 2057 - Vila Lisboa, São Paulo - SP</p>
            </li>
            <li>
              <i className="fa-brands fa-whatsapp"></i>
              <p>11 3201-2009</p>
            </li>
            <li>
              <i className="fa-solid fa-envelope"></i>
              <p>vendas@ficael.com</p>
            </li>
          </ul>
        </div>
        <div className="contact-form-container">
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <div className="input-group">
              <input
                name="name"
                type="text"
                className="form-control"
                placeholder="Nome"
                required
              />
            </div>
            <div className="input-group">
              <input
                name="email"
                type="email"
                className="form-control"
                placeholder="E-mail"
                required
              />
            </div>
            <div className="input-group">
              <textarea
                name="message"
                className="form-control"
                rows="5"
                placeholder="Mensagem..."
                required
              ></textarea>
            </div>
            <button 
              type="submit" 
              className={`btn btn-primary ${isLoading ? "loading" : ""}`} 
              disabled={isLoading} // Desativa o botão durante o carregamento
            >
              {isLoading ? "Enviando..." : "Enviar Mensagem"}
              {isLoading && <div className="spinner"></div>} {/* Adiciona o spinner */}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
